
import RouterWithSSR from '../RouterWithSSR';
import displayName from '../helpers/displayName';

export default function (WrappedComponent) {
  function wrappedInRouter(props) {
    return (
      <RouterWithSSR>
        <WrappedComponent {...props} />
      </RouterWithSSR>
    );
  }

  wrappedInRouter.displayName = `wrappedInRouter(${displayName(WrappedComponent)})`;

  return wrappedInRouter;
}
